import { MimetypeDto } from '@sr/dto';
import { useCallback } from 'react';
import { authorizedRequest } from 'shared/api/axios';
import { useReadOnlyRemoteCollection } from 'utils/remote-collection.hook';


export const useMimetypeDropdown = () => {
  return useReadOnlyRemoteCollection<MimetypeDto>({
    fetchHandler: useCallback(() => { return authorizedRequest<void, MimetypeDto[]>('/files/mimetype', 'GET') }, [])
  });
};
